import React from 'react';
import { Empty, Typography } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function PortfolioStressTestingTab() {
  return (
    <div className="mpd-tab-panel mpd-tab-panel--empty">
      <Empty
        image={<ExperimentOutlined style={{ fontSize: 48, color: '#94a3b8' }} />}
        description={
          <div>
            <Typography.Title level={5} style={{ margin: '0 0 8px' }}>
              Stress testing
            </Typography.Title>
            <Text type="secondary">
              Rate shock, spread widening, and liquidity stress scenarios will appear here.
            </Text>
          </div>
        }
      />
    </div>
  );
}
